<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:width="width"
		:height="height"
		fill="currentColor"
		class="ki ki-arrow-right-parens"
		viewBox="0 0 24 24"
	>
		<path
			d="M6 20c-2.4-1.8-4-4.7-4-8s1.6-6.2 4-8v1.3C4.2 7 3 9.3 3 12s1.2 5 3 6.7V20zM18 4v1.3c1.8 1.7 3 4 3 6.7s-1.2 5-3 6.7V20c2.4-1.8 4-4.7 4-8s-1.6-6.2-4-8zM6 12.5h10l-4.5 5H13l5-5.5-5-5.5h-1.5l4.5 5H6v1z"
		/>
	</svg>
</template>

<script setup lang="ts">
interface Props {
	width?: number;
	height?: number;
}
withDefaults(defineProps<Props>(), {
	width: 24,
	height: 24
});
</script>
